import React from 'react';
import ApplicationWrp from '@framework/ui/Templates/ApplicationWrp';
import ContentWrp from '@framework/ui/Templates/ContentWrp';

interface IProps {
  children: React.ReactNode,
}

const Layout = (props: IProps) => (
  <>
    <ApplicationWrp>
      <ContentWrp>
        { props.children }
      </ContentWrp>
    </ApplicationWrp>
  </>
);

export default Layout;
